export default __webpack_public_path__ + "static/media/Sydney.72fa8807.jpg";